import { createStandardAction } from 'typesafe-actions'


export const saveUser = createStandardAction(
  '@@user/SAVE_USER'
)()

export const clearUser = createStandardAction(
  '@@user/CLEAR_USER'
)()